import React from "react";
import { GENDERS } from "Constants";
import OperationsColumn from "./operations-column";
import Highlighter from "react-highlight-words";
import StateTag from "Components/state-tag";
import { Table } from "antd";
import { formatDate, sort } from "Utils";

export default function PartnersTable({
  data = [],
  IsAuthorized,
  loading,
  filteredValue,
  onSetFilteredValue,
  onOperationExecuted,
  ...props
}) {
  const columns = [
    {
      title: "Kod",
      dataIndex: "code",
      key: "code",
      width: 80,
      sorter: (a, b) => {
        return a.code.substr(1) - b.code.substr(1);
      },
      render: (text, record) => (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[filteredValue.fastSearchParam || ""]}
          autoEscape
          textToHighlight={record.code}
        />
      ),
    },
    {
      title: "Hitap/Cins.",
      dataIndex: ["title", "description"],
      render: (text, record) => (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[filteredValue.fastSearchParam || ""]}
          autoEscape
          textToHighlight={record.title?.description || GENDERS[record.gender]}
        />
      ),
      key: "title",
      width: 120,
      ellipsis: true,
      sorter: (a, b) => {
        return sort(
          a.title?.description || GENDERS[a.gender],
          b.title?.description || GENDERS[b.gender]
        );
      },
    },
    {
      title: "Ad Soyad",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <>
          <StateTag state={record.state} />
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[filteredValue.fastSearchParam || ""]}
            autoEscape
            textToHighlight={record.name + " " + (record.surname || "")}
          />
        </>
      ),
      sorter: (a, b) => {
        return sort(a.name + " " + a.surname, b.name + " " + b.surname);
      },
      width: 170,
      ellipsis: true,
    },

    {
      title: "Muhatap Tipi",
      dataIndex: "partnerRoles",
      render: (record) => {
        let roles = [];
        if (record)
          record.forEach((role) => {
            roles.push(role.type.description);
          });
        return roles.toString();
      },
      key: "partnerType",
      width: 180,
      ellipsis: true,
    },

    {
      title: "Adres",
      dataIndex: "address",
      key: "address",
      width: 200,
      ellipsis: true,
    },

    {
      title: "E-Posta",
      dataIndex: "email",
      key: "email",
      width: 170,
      ellipsis: true,
      sorter: (a, b) => {
        return sort(a.email, b.email);
      },
    },

    {
      title: "Vergi Dairesi",
      dataIndex: "taxOffice",
      key: "taxOffice",
      width: 160,
      ellipsis: true,
      sorter: (a, b) => {
        return sort(a.taxOffice, b.taxOffice);
      },
    },

    {
      title: "Yaratma Tarihi",
      dataIndex: "createdAt",
      key: "createdAt",
      sorter: (a, b) => {
        return sort(a.createdAt, b.createdAt);
      },
      width: 170,
      ellipsis: true,
      render: (text, record) => formatDate(record.createdAt),
    },
    {
      title: "İşlemler",
      width: 150,
      fixed: "right",
      dataIndex: "operation",
      render: (text, record) => (
        <OperationsColumn
          record={record}
          onOperationExecuted={onOperationExecuted}
        />
      ),
    },
  ];

  return (
    <Table
      rowKey={(row) => row.id}
      style={{ margin: "0 24px" }}
      loading={loading}
      dataSource={data}
      pagination={{
        total: data.length,
        pageSize: 20,
        showSizeChanger: false,
        showTotal: (total, range) => {
          return `Toplam ${total} sonuçtan ${range.join(
            "-"
          )} arası gösteriliyor.`;
        },
      }}
      locale={{
        filterConfirm: "Filtrele",
        filterReset: "Temizle",
        emptyText: IsAuthorized
          ? "Kayıt Bulunamadı"
          : "Bu işlem için yetkiniz yok. Sistem yöneticiniz ile iletişime geçebilirsiniz.",
      }}
      columns={columns}
      bordered
      size="small"
      bordered
      showSorterTooltip={false}
      scroll={{ x: 1000, scrollToFirstRowOnChange: true }}
    />
  );
}
